/**
 * The visitor's answer to the banner about cookies: may counters run (`all`), or only
 * what the site cannot work without (`necessary`). No answer yet: null, and nothing runs.
 *
 * Kept in a cookie of the whole domain, as the language is: the front page and the
 * application are on different hosts, and the visitor answers once for both. Read by the
 * application and by the static front page (site/consent.ts) alike.
 */
export type Consent = 'all' | 'necessary';

export const CONSENT_COOKIE = 'easymusic_consent';
const YEAR = 365 * 86_400;

export function readConsent(cookies: string = document.cookie): Consent | null {
  const pair = cookies.split('; ').find((entry) => entry.startsWith(`${CONSENT_COOKIE}=`));
  const value = pair?.slice(CONSENT_COOKIE.length + 1);
  return value === 'all' || value === 'necessary' ? value : null;
}

/** Remember the answer for a year, for every host of `domain` (none: this host only). */
export function rememberConsent(consent: Consent, domain?: string | null): void {
  const scope = domain ? `; Domain=${domain}` : '';
  document.cookie = `${CONSENT_COOKIE}=${consent}${scope}; Path=/; Max-Age=${YEAR}; SameSite=Lax`;
}

/** Forget the answer: the visitor is asked again (the policy page offers it). */
export function forgetConsent(domain?: string | null): void {
  const scope = domain ? `; Domain=${domain}` : '';
  document.cookie = `${CONSENT_COOKIE}=${scope}; Path=/; Max-Age=0; SameSite=Lax`;
}
